module.exports = __webpack_public_path__ + "img/codepen-icon.6b21a536.svg";